module.exports = __webpack_public_path__ + "static/media/16.3954d795.JPG";